import { createSelector } from 'reselect'
import _ from 'lodash'

const getPoints = state => state.Points.data
const getTags = state => state.Tags.data
const getClasifications = state => state.Clasifications.data

const getPointsWithClasifications = createSelector(
  [
    getPoints,
    getClasifications,
  ],
  (...allState) => {
    const [
      points,
      clasifications,
    ] = allState

    const clasificationsKeyed = _.keyBy(clasifications, '_id')
    return _.map(points, x => ({
      ...x,
      clasification: (clasificationsKeyed[x.clasification_id]
        && clasificationsKeyed[x.clasification_id].name)
        || 'Sin Clasificación',
    }))
  },
)

export const getPointsWithTags = createSelector(
  [
    getPointsWithClasifications,
    getTags,
  ],
  (...allState) => {
    const [
      points,
      tags,
    ] = allState

    const tagsKeyed = _.keyBy(tags, '_id')

    const pointsWithTags = _.map(points, point => ({
      ...point,
      tags: _.reduce(point.tags, (acum, tag) => {
        if (tagsKeyed[tag]) {
          return acum.concat(tagsKeyed[tag].name)
        }

        return acum
      }, []),
    }))

    return {
      points: pointsWithTags,
    }
  },
)
